(function($){

	// Settings
	var defaults = {
		hover: true, // On mobile it will always be on tap
		hoverOut: undefined, // Hide the tooltip when mouse out or on click
		touch: true, // False will prevent the tooltip showing on touch devices
		clickDefault: true, // Set to false to preventDefault on the target element
		content: 'data-tooltip', // Can be a string, data-tag, an id (#id), a $jquery object or a URL
		position: 't', // x then y - e.g: rt, lb, r, b
		fixed: false, // Default is absolute, the maths is quite different if fixed
		margin: 10, // This is the closest the tooltip will ever get to the window edge
		style: false,
		clone: false, // When grabbing content, clone it or not ()
		arrow: true, // This is an <i> element for use as a css arrow
		loading: 'Loading',
		clickOutsideToClose: true, // This only applies tooltips opened with a click
		close: false, // Adds a close button to the tooltip
		hideOnScroll: true, // Only applies if hover is true and not on mobile
		in: function(){},
		out: function(){}
	};

	// Create a universal tooltip and container
	var tVisible = false,
		ajax = false,
		timer = false,
		$win = $(window),
		$body = $('body'),
		$tooltip = $('<div class="tooltip__wrapper"></div>').appendTo( $body );

	// Store a global tooltip object
	$tooltip = {
		root: $tooltip,
		inner: $('<div class="tooltip"></div>').appendTo($tooltip),
		close: $('<span class="tooltip__close"><i class="icon-x"></i></span>'),
		arrow: $('<i class="tooltip__arrow"></i>'),
		loading: $('<span class="tooltip__loading"></span>'),
		content: false,
		originalContent: false,
		placeholder: false,
		target: false
	};


	/*
		Works out the content type and generates an object
		for the content that will be placed in the tooltip
	*/
	var getContent = function(src, $target){

		var content = null,
			type = '',
			str = typeof src == 'string';

		// Data tag
		if( str && src.indexOf('data-') === 0 ){

			// This is a bit more complex than the rest:
			// The data tag could hold the content itself or
			// a reference using any other supported methods
			// so we loop through this function again against
			// the content of the data tag
			var input = getContent( $target.data( src.replace('data-', '') ) );

			content = input.content;
			type = input.type;

		// URL
		}else if( str && src.indexOf('/') === 0 ){

			content = src;
			type = 'url';

		// ID
		}else if( str && src.indexOf('#') === 0 ){

			content = $(src);
			type = 'id';

		// String or jQuery object
		}else if( str || typeof src == 'object' ){

			content = src;
			type = str ? 'str' : 'obj';

		}else if( typeof src == 'function' ){

			content = src($tooltip);
			type = 'function';

		}

		return {
			content: content,
			type: type
		};

	};


	/*
		Shows the tooltip
	*/
	var showTooltip = function(s){

		var attempts = $tooltip.target.data('attempts');

		$tooltip.target.addClass('tooltip--active');

		// Add a placeholder to the page if needed
		if( ( s.type == 'obj' || s.type == 'id' || s.type == 'function' ) && !s.options.clone && !attempts ){

			$tooltip.placeholder = $('<span/>', {
				'class': 'tooltip__placeholder'
			}).insertAfter( $tooltip.content );

		}

		// Empty the tooltip and add the new content
		$tooltip.inner
			.empty()
			.append( $tooltip.content );

		// If there is an arrow add that into the inner
		if( s.options.arrow )
			$tooltip.arrow.appendTo($tooltip.inner);

		// If there is a close button add that into the inner
		if( s.options.close )
			$tooltip.close.clone(true).appendTo($tooltip.inner);

		// If there is a style
		if( s.options.style ){

			var styleArray = s.options.style.split(','),
				styles = '';

			for( var i = styleArray.length - 1; i >= 0; i-- ){
				styles = styles + 'tooltip--' + styleArray[i] + ' ';
			};

		}


		// Remove any existing classes and add our new ones
		$tooltip.root
			.attr('class', 'tooltip__wrapper')
			.addClass( ( s.options.style ? styles : '' ) + ' tooltip--pos-' + s.options.position );

		var arrowRotation = '';

		if( s.options.position == 't' )
			arrowRotation = 0;

		if( s.options.position == 'r' )
			arrowRotation = 90;

		if( s.options.position == 'b' )
			arrowRotation = 180;

		if( s.options.position == 'l' )
			arrowRotation = -90;

		TweenLite
			.set($tooltip.arrow, {
				rotation: arrowRotation
			});

		// In callback
		s.options.in($tooltip);

		// Set the tooltip width
		$tooltip.root
			.css({
				maxWidth: site.width - ( s.options.margin * 2 )
			});

		// Get the offset of the target
		var offset = $tooltip.target.offset(),

			// Get the width / height of the target
			w = $tooltip.target.outerWidth(),
			h = $tooltip.target.outerHeight(),

			// Get the width / height of the tooltip
			tw = $tooltip.root.outerWidth(),
			th = $tooltip.root.outerHeight(),

			// Set the default positions for the tooltip
			top = offset.top + ( h / 2 ) - ( th / 2 ),
			left = offset.left + ( w / 2 ) - ( tw / 2 ),

			// Build an object for all the possible positions
			a = {
				t: s.options.position.indexOf('t'),
				r: s.options.position.indexOf('r'),
				b: s.options.position.indexOf('b'),
				l: s.options.position.indexOf('l')
			},

			// Work out the start position for animation
			x = a.l == 0 || a.r == 0 ? a.l == 0 ? -20 : 20 : 0,
			y = a.t == 0 || a.b == 0 ? a.t == 0 ? -20 : 20 : 0;

		// Work out the complex positions to override default if necessary (one will always be overwritten)
		if( a.t >= 0 ) top = a.t == 0 ? offset.top - th : offset.top;
		if( a.b >= 0 ) top = a.b == 0 ? offset.top + h : offset.top + h - th;
		if( a.l >= 0 ) left = a.l == 0 ? offset.left - tw : offset.left;
		if( a.r >= 0 ) left = a.r == 0 ? offset.left + w : offset.left + w - tw;

		var diff = {
			x: 0,
			y: 0
		};

		if( top < site.scroll.y + s.options.margin ){

			diff.y = top - site.scroll.y - s.options.margin;
			top = site.scroll.y + s.options.margin;

		}else if( top + th > site.scroll.y + site.height - s.options.margin ){

			var yDist = site.scroll.y + site.height - s.options.margin - th;

			diff.y = top - yDist;
			top = yDist;

		}

		if( left < s.options.margin ){

			diff.x = left - s.options.margin;
			left = s.options.margin;

		}else if( left + tw > site.width - s.options.margin ){

			diff.x = left + tw - ( site.width - s.options.margin );
			left = site.width - s.options.margin - tw;

		}

		// Swap l / r or t / b if the tooltip isn't in the viewport

		var originalPosition = $tooltip.target.data('originalPosition');

		if( !originalPosition ){

			originalPosition = s.options.position;
			$tooltip.target.data('originalPosition', originalPosition);

		}

		if( !attempts )
			attempts = 0;

		// Check if we are swapping anything
		var swap = {
			t: a.t >= 0 && ( top < site.scroll.y + s.options.margin || diff.y < 0 ),
			r: a.r >= 0 && diff.x > 0,
			b: a.b >= 0 && ( top + th > site.scroll.y + site.height || diff.y > 0 ),
			l: a.l >= 0 && diff.x < 0
		};

		// Give up if we've failed 4 times
		if( attempts < 4 && ( swap.t || swap.r || swap.b || swap.l ) ){

			if( originalPosition == 't' ) s.options.position = ['t','b','r','l'][attempts];
			if( originalPosition == 'b' ) s.options.position = ['b','t','r','l'][attempts];
			if( originalPosition == 'r' ) s.options.position = ['r','l','t','b'][attempts];
			if( originalPosition == 'l' ) s.options.position = ['l','r','t','b'][attempts];

			attempts++;

			$tooltip.target.data('attempts', attempts);

			showTooltip(s);

			return;

		}

		// If it worked, reset the attempts and position
		// If it failed miserably, then give it your best shot!
		$tooltip.target.data('attempts', 0);
		s.options.position = originalPosition;

		TweenLite
			.set($tooltip.arrow, {
				x: diff.x,
				y: diff.y
			});

		// Position the tooltip
		TweenLite
			.set($tooltip.root, {
				position: s.options.fixed ? 'fixed' : 'absolute',
				top: top - ( s.options.fixed ? site.scroll.y : 0 ),
				left: left - ( s.options.fixed ? site.scroll.x : 0 ),
				pointerEvents: !Modernizr.touchevents && s.options.hover ? 'none' : 'auto'
			});

		// Fade it in (autoAlpha automatically sets visibility as well)
		TweenLite
			.fromTo($tooltip.root, .1, {
				autoAlpha: 0
			},{
				autoAlpha: 1
			});

		// Move it from one position to the final position depending on calculations above
		TweenLite
			.fromTo($tooltip.inner, .3, {
				y: y,
				x: x
			},{
				y: 0,
				x: 0,
				force3D: true,
				ease: Bounce.easeOut
			});

		$win.on('resize.tooltip', hideTooltip);

		if( s.options.hideOnScroll && !Modernizr.touchevents && s.options.hover )
			$core.doc.on('scroll.tooltip', hideTooltip);

		// The tooltip is now visible
		tVisible = true;

	};

	/*
		Hides the tooltip and removes any events
		that have previously been set
	*/
	var hideTooltip = function(){

		// Clear the delay timer (for Ajax requests)
		clearTimeout(timer);

		// If there is a placeholder set put the content back where it came from
		if( $tooltip.placeholder ){

			$tooltip.content.insertAfter( $tooltip.placeholder );
			$tooltip.placeholder.remove();
			$tooltip.placeholder = false;

		}

		// Hide the tooltip instantly (no animations on hide as we may be about to show another tooltip)
		TweenLite
			.set($tooltip.root, {
				visibility: 'hidden',
				overwrite: 'all',
				clearProps: 'all'
			});

		$tooltip.target.removeClass('tooltip--active');
		$body.off('.tooltip');

		// Tooltip is now hidden
		tVisible = false;

		$win.off('.tooltip');
		$core.doc.off('.tooltip');

	};

	/*
		A jQuery plugin
	*/
	$.fn.tooltip = function(settings) {

		// Get the global options for this instance of the plugin - this can be overwritten using the data tag
		var globalOptions = $.extend({}, defaults, settings);

		// Remove the event
		if( settings == 'remove' ){
			$(this).off('.tooltip');
			return this;
		}

		// Loop through each of the targets
		return this.each(function(){

			// Get the target plus merge in the data tag options for each one
			var $this = $(this),
				options = $.extend({}, globalOptions, $this.data());

			if( options.hoverOut === undefined )
				options.hoverOut = options.hover;

			// Don't go any further if we're on a touch device with touch disabled
			if( Modernizr.touchevents && !options.touch ) return false;

			// Add the appropriate events to the target depending on options and device
			$this
				.on( !Modernizr.touchevents && options.hover ? 'mouseenter.tooltip' : 'click.tooltip', function(e){

					// Set the target
					$tooltip.target = $this;

					// If we're clicking an already active tooltip just close it and stop here…
					if( tVisible && $this == $tooltip.target ){

						hideTooltip();
						return false;

					// …or if there is one open, but this is a different one just hide the tooltip
					}else if( tVisible ){

						hideTooltip();

					}

					// Get the tooltip content object, returns type and content
					var input = getContent(options.content, $this);

					// If this is a URL, add the loading text to the loading element
					if( input.type == 'url' )
						$tooltip.loading.html( options.loading );

					// Add the content (or loading spinner) and store the target
					$tooltip.content = input.type == 'url' ? $tooltip.loading : input.content;
					$tooltip.originalContent = false;

					// If we are cloning rather than removing / replacing
					if( options.clone ){

						$tooltip.originalContent = $tooltip.content;
						$tooltip.content = $tooltip.content.clone().removeAttr('id');

					}

					// Insert a delay if it's an ajax request so that we don't show the spinner for no reason
					timer = setTimeout(function(){

						// Show the tooltip
						showTooltip({
							options: options,
							type: input.type
						});

					}, input.type == 'url' ? 100 : 0);

					// If that was a URL, start an ajax request
					if( input.type == 'url' ){

						$.ajax({
							url: input.content
						})
						.then(function(data){

							// Clear the timer that shows the loading spinner
							clearTimeout(timer);

							// Add the data
							$tooltip.content = data;

							showTooltip({
								options: options,
								type: input.type
							});

						});

					}

					// If this is on hover, set up a mouseleave event (never on mobile)
					if( options.hoverOut && !Modernizr.touchevents ){

						// Set up a mouse leave event
						$tooltip.target
							.on('mouseleave.tooltip', function(){

								// If it's visible, hide it
								if( tVisible )
									hideTooltip();

								// Remove this event
								$(this).off('mouseleave.tooltip');

							});

					}else if( options.clickOutsideToClose ){

						setTimeout(function(){

							$tooltip.root
								.on('click.tooltip', function(e){

									e.stopPropagation();

								});

							$body
								.on('click.tooltip', function(){

									if( tVisible )
										hideTooltip();

								});

						}, 50);

					}

					if( !options.clickDefault )
						e.preventDefault();

				});

		});

	};

	// Close the tooltip with the close button
	$tooltip.close
		.on('click', hideTooltip);

	// Default plugin application
	$('[data-tooltip]')
		.tooltip();

})(jQuery);